module.exports = __webpack_public_path__ + "static/assets/6f259a1673f619235db10ff7a517e820.svg";